module.exports = __webpack_public_path__ + "static/media/paz-comunidad.e199760b.png";